'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/radio/style/css');

var _radio = require('antd/lib/radio');

var _radio2 = _interopRequireDefault(_radio);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RadioButton = _radio2.default.Button;
var RadioGroup = _radio2.default.Group;
var Search = _input2.default.Search;

var UserFilter = _react2.default.createClass({
    displayName: 'UserFilter',

    propTypes: {
        states: _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired,
        levels: _react.PropTypes.arrayOf(_react.PropTypes.string.isRequired).isRequired,
        filter: _react.PropTypes.object.isRequired,
        onChange: _react.PropTypes.func.isRequired
    },
    onStateChange: function onStateChange(e) {
        this.props.onChange('state', e.target.value);
    },
    onLevelChange: function onLevelChange(e) {
        this.props.onChange('level', e.target.value);
    },
    onKeywordChange: function onKeywordChange(keyword) {
        this.props.onChange('keyword', keyword);
    },
    render: function render() {
        return _react2.default.createElement(
            'div',
            { className: 'filter' },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u5BA2\u6237\u7B49\u7EA7\uFF1A'
                ),
                _react2.default.createElement(
                    RadioGroup,
                    { onChange: this.onLevelChange, defaultValue: '\u5168\u90E8' },
                    _react2.default.createElement(
                        RadioButton,
                        { value: '\u5168\u90E8' },
                        '\u5168\u90E8'
                    ),
                    this.props.levels.map(function (level) {
                        return _react2.default.createElement(
                            RadioButton,
                            { key: level, value: level },
                            level
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u5BA2\u6237\u72B6\u6001\uFF1A'
                ),
                _react2.default.createElement(
                    RadioGroup,
                    { onChange: this.onStateChange, defaultValue: '\u5168\u90E8' },
                    _react2.default.createElement(
                        RadioButton,
                        { value: '\u5168\u90E8' },
                        '\u5168\u90E8'
                    ),
                    this.props.states.map(function (state) {
                        return _react2.default.createElement(
                            RadioButton,
                            { key: state, value: state },
                            state
                        );
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'label',
                    null,
                    '\u5173\u952E\u8BCD\uFF1A\xA0\xA0\xA0\xA0'
                ),
                _react2.default.createElement(Search, {
                    placeholder: '\u5BA2\u6237\u540D\u79F0/\u624B\u673A\u53F7\u7B49\uFF0C\u6309\u56DE\u8F66\u952E\u641C\u7D22',
                    onSearch: this.onKeywordChange
                })
            )
        );
    }
});

exports.default = UserFilter;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_filter.js
// module id = 1324
// module chunks = 0